<template>
  <transition name='fade'>
    <div
      class="modal"
      v-if='visible && batchArticleData.length>0'
      style="z-index:1002;"
    >
      <div
        class="batch_operate"
        v-loading='sendLoading'
        element-loading-text="提交中,请稍后"
      >
        <div class="batch_operate_title msp_icon_close">
          <span
            class="name"
            v-if='batchArticleType === "batchoperateAudit"'
          >送审</span>
          <span
            class="name"
            v-if='batchArticleType === "batchOperateMoveArticle"'
          >移动</span>
          <span
            class="name"
            v-if='batchArticleType === "batchOperateDeleteArticle"'
          >删除</span>

          <span
            class="name"
            v-if='batchArticleType === "batchOperateSaveAsArticle"'
          >另存</span>

          <span
            class="iconfont el-icon-close"
            @click.stop='closeBox()'
          ></span>
        </div>
        <div class="batch_operate_detail">
          <div
            class="batch_title_info"
            v-if='batchArticleType === "batchoperateAudit"'
          >
            <span v-if="batchArticleData[0].doc_type!='document'">是否将以下稿件送审至</span>
            <span v-if="batchArticleData[0].doc_type=='document'">是否将以下文档送审至</span>
            <span class="user">{{senduser.name}}</span>
          </div>

          <div
            class="batch_title_info"
            v-if='batchArticleType === "batchOperateMoveArticle"'
          >
            <span v-if="batchArticleData[0].doc_type!='document'">是否移动以下稿件</span>
            <span v-if="batchArticleData[0].doc_type=='document'">是否移动以下文档</span>
          </div>

          <div
            class="batch_title_info"
            v-if='batchArticleType === "batchOperateSaveAsArticle"'
          >
            <span v-if="batchArticleData[0].doc_type!='document'">是否另存以下稿件</span>
            <span v-if="batchArticleData[0].doc_type=='document'">是否另存以下文档</span>
          </div>

          <div
            class="batch_title_info"
            v-if='batchArticleType === "batchOperateDeleteArticle"'
          >
            <span v-if="batchArticleData[0].doc_type!='document'">是否删除以下稿件</span>
            <span v-if="batchArticleData[0].doc_type=='document'">是否删除以下文档</span>
          </div>

          <el-table
            :data="batchArticleData"
            height="360"
            style="width: 99.9%"
          >
            <el-table-column
              prop="title"
              :label="batchArticleData[0].doc_type!='document'?'稿件名称':'文档名称'"
            >
            </el-table-column>
            <el-table-column
              prop="creator"
              label="创建人"
              width="160"
            >
            </el-table-column>
            <el-table-column
              label="操作"
              width="80"
            >
              <template slot-scope="scope">
                <span
                  class="iconfont el-icon-close"
                  style="color:#F56969;font-size:20px;cursor:pointer;"
                  @click.stop="deleteTableArticle(scope.row)"
                ></span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="operate_button">
          <el-button @click.native='closeBox()'>取 消</el-button>
          <el-button
            type="primary"
            @click.native='sureSendAudit()'
          >确 定</el-button>
        </div>

      </div>
    </div>
  </transition>
</template>

<script>

import * as api from '../../../api'

export default {
  name: 'batchoperate',
  data () {
    return {
      visible: false,
      batchArticleData: [],
      batchArticleType: '',
      senduser: '',
      sendLoading: false
    }
  },

  mounted () {
    this.$root.eventHub.$on('batchoperateModel', (data, type, senduser) => {
      this.visible = true
      this.batchArticleData = data
      this.batchArticleType = type
      if (type === 'batchoperateAudit' || type === 'batchOperateMoveArticle') {
        this.senduser = senduser[0]
      } else if (type === 'batchOperateSaveAsArticle') {
        this.senduser = senduser
      }
    })


  },
  destroyed () {
    this.$root.eventHub.$off('batchoperateModel')
  },
  components: {

  },
  methods: {
    closeBox () {
      this.visible = false
    },
    deleteTableArticle (item) {
      for (var i = 0; i < this.batchArticleData.length; i++) {
        if (item.id === this.batchArticleData[i].id) {
          this.batchArticleData.splice(i, 1);
          break;
        }
      }
      this.$root.eventHub.$emit('setCurrentChoiceArticle', this.batchArticleData)
    },
    sureSendAudit () {
      var url = ''
      var idArr = []
      var option = ''
      var successMessage = ''
      var errorMessage = ''
      var url = ''
      for (var i = 0; i < this.batchArticleData.length; i++) {
        idArr.push(this.batchArticleData[i].id)
      }
      if (this.batchArticleType === 'batchoperateAudit') {
        if (this.batchArticleData[0].doc_type === 'document') {
          url = _API_ + 'api/article/doc/audit/batch_audit_request'
        } else {
          url = _API_ + 'api/article/audit/batch_audit_request'
        }
        option = {
          ...this.$store.getters.baseOption,
          'params': {
            "list_id": idArr,    // 必须字段： 审核对象的 id 列表
            "content_type": "article",            // 必须字段：类型  稿件为  article
            "id_to_user": this.senduser.id                   // 必须字段：指定的审核人的用户 ID
          }
        }
        successMessage = '提交送审成功'
        errorMessage = '提交送审失败'

      } else if (this.batchArticleType === 'batchOperateMoveArticle') {
        url = _API_ + 'api/article/utils/move_article'
        option = {
          ...this.$store.getters.baseOption,
          "params": {          // 必须字段：  参数
            "list_id": idArr,             // 文章ID集合
            "target_id_repo": this.senduser.id_repo,  //目标库id
            "target_id_folder": this.senduser.id  //目标文件夹id
          }
        }
        successMessage = '移动成功'
        errorMessage = '移动失败'
      } else if (this.batchArticleType === 'batchOperateDeleteArticle') {
        url = _API_ + 'api/article/editor/delete_article'
        option = {
          ...this.$store.getters.baseOption,
          "params": {          // 必须参数： 参数字段，所有需要用到的参数，在此字段内传输
            "list_id": idArr    // 必须参数： 文章ID列表
          }
        }
        successMessage = '删除成功'
        errorMessage = '删除失败'
      } else if (this.batchArticleType === 'batchOperateSaveAsArticle') {
        var ids = []
        for (var i = 0; i < this.senduser.length; i++) {
          if (!this.senduser[i].flag_repo) {
            ids.push(this.senduser[i].id)
          }
        }
        url = _API_ + 'api/article/utils/article_save_news'
        option = {
          ...this.$store.getters.baseOption,
          'params': {          // 必须字段：  参数
            "id_articles": idArr,         // 必须字段： 稿件id
            "folder_ids": ids        //另存到的文件夹的 ID
          }
        }
        successMessage = '另存成功'
        errorMessage = '另存失败，请稍后重试'
      }

      this.sendLoading = true
      api._post(url, option).then((res) => {
        if (res.code == 200) {
          this.$notify.success({
            title: '成功',
            message: successMessage
          });
          if (this.batchArticleType === 'batchoperateAudit') {
            for (var i = 0; i < this.batchArticleData.length; i++) {
              this.$set(this.batchArticleData[i], 'audit_status', 'doing')
            }
          } else if (this.batchArticleType === 'batchOperateMoveArticle' || this.batchArticleType === 'batchOperateDeleteArticle') {
            for (var i = 0; i < this.batchArticleData.length; i++) {
              this.$root.eventHub.$emit('deleteMoveArticle', this.batchArticleData[i])
            }

          }
          this.batchArticleData.splice(0, this.batchArticleData.length)
          this.$root.eventHub.$emit('setCurrentChoiceArticle', [])
        } else {
          this.$notify.error({
            title: '错误',
            message: errorMessage
          });
        }
        this.sendLoading = false
      }).catch((error) => {
        this.$notify.error({
          title: '错误',
          message: errorMessage
        });
        this.sendLoading = false
      })
    }


  },
  watch: {
    batchArticleData () {
      if (this.batchArticleData.length === 0) {
        this.visible = false
      }
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='stylus' scoped>
.batch_operate
  position relative
  z-index 100
  width 586px
  height 548px
  border-radius 6px
  background #FFFFFF
  box-shadow 0px 1px 4px 0px rgba(0, 0, 0, 0.35)

  .batch_operate_title
    box-sizing border-box
    margin-bottom 20px
    padding 0 20px 0 20px
    width 100%
    height 62px
    border-radius 6px 6px 0px 0px
    background rgba(255, 255, 255, 1)
    box-shadow 0px 0px 4px 0px rgba(0, 0, 0, 0.2)

    span
      color #303133
      font-size 16px
      line-height 62px

    span.iconfont
      float right
      color #606266
      font-size 20px
      cursor pointer

  .batch_operate_detail
    padding-left 20px

    .batch_title_info
      margin-bottom 10px

      span
        time-title()

      .user
        color #688EFF

  .operate_button
    display flex
    justify-content center
    padding-top 20px
    width 100%

    button
      padding 0
      width 78px
      height 32px
      line-height 0
</style>
